module.exports = __webpack_public_path__ + "static/favicon-7fca6216a5510bed76a40dce8280bba6.ico";